<template>
  <div
    v-if="hasAnyRatings"
    class="grid grid-cols-1 gap-3 py-4 px-6 bg-gray-50 rounded-lg"
  >
    <template v-if="isAIRatings">
      <div
        v-for="rating in ratings"
        :key="rating.category"
        class="flex items-center gap-2"
      >
        <div class="flex-1">
          <span class="text-sm font-medium text-gray-600">
            {{ rating.category }}
          </span>
          <p class="text-xs text-gray-500 mt-1">
            {{ rating.summary }}
          </p>
        </div>
        <div class="flex items-center gap-2 min-w-[120px] justify-end">
          <RatingStars
            :rating="rating.average"
            size="sm"
          />
          <span class="text-sm text-gray-500">
            {{ rating.average }}/5
            <span class="text-xs">({{ rating.count }})</span>
          </span>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        v-for="[criterion, rating] in Object.entries(ratingDetails)"
        :key="criterion"
        class="flex items-center gap-2"
      >
        <span class="text-sm font-medium text-gray-600 flex-1">
          {{ getCriteriaLabel(criterion) }}
        </span>
        <div class="flex items-center gap-2 min-w-[120px] justify-end">
          <RatingStars
            :rating="rating"
            size="sm"
          />
          <span class="text-sm text-gray-500 min-w-[32px] text-right">
            {{ rating }}/5
          </span>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
interface Rating {
  category: string
  average: number
  count: number
  summary: string
}
const RATING_CRITERIA = {
  compensation_benefits: 'Compensation / Benefits',
  culture: 'Culture',
  management: 'Management',
  work_life_balance: 'Work / Life Balance',
  security_advancement: 'Security / Advancement'
}
const props = defineProps<{
  ratings?: Rating[]
  ratingDetails?: Record<string, number>
}>()
const isAIRatings = computed(() => Boolean(props.ratings))
const getCriteriaLabel = (criterion: string) => {
  if (RATING_CRITERIA[criterion]) {
    return RATING_CRITERIA[criterion]
  }
  return criterion
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
const hasAnyRatings = computed(() => {
  if (isAIRatings.value) {
    return props.ratings?.some(rating => rating.average > 0) ?? false
  } else {
    return Object.values(props.ratingDetails || {}).some(rating => rating > 0)
  }
})
</script>
